export default __webpack_public_path__ + "static/media/Path3459.dc8ae9bb.svg";